import styled, { keyframes } from "styled-components";

const dotAnimation = keyframes`
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
`;

export const StyledDotsLoader = styled.span`
  display: inline-block;
  text-align: center;

  & > span {
    display: inline-block;
    width: 18px;
    height: 18px;
    background-color: #777;
    border-radius: 100%;
    animation: ${dotAnimation} 1.4s infinite ease-in-out both;
  }

  span:nth-child(1) {
    animation-delay: -0.32s;
  }
  span:nth-child(2) {
    animation-delay: -0.16s;
  }
`;
